import React, { useMemo, useRef, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Popper, Tooltip } from "@material-ui/core";
import { CustomIcon } from "../../../components/CustomIcon";
import EventLabel from "../../../components/EventLabel";

export const VoucherLinkDialog = ({ contentLayoutCode, exhibitorId, personTypeId, onClose, ...voucher }) => {
  const [showPopper, setShowPopper] = useState(false);
  const linkUrl = useMemo(() => {
    return `https://${window.location.host}${window.location.host.includes("localhost") ? "" : "/cms"}/web/${contentLayoutCode}?exi=${exhibitorId}&pti=${personTypeId}`;
  }, [contentLayoutCode, exhibitorId, personTypeId]);
  const copyRef = useRef();
  const onCopyClick = () => {
    navigator.clipboard.writeText(linkUrl);
    setShowPopper(true);
    setTimeout(() => setShowPopper(false), 2000);
  };
  return (
    <Dialog open={true} onClose={onClose}
    maxWidth={"md"}
    fullWidth={true}
    aria-labelledby="invite-link-dialog-title">
      <DialogTitle id="invite-link-dialog-title">
        <EventLabel name="InviteLinkDialogTitle" groupName="CMS.Voucher" />
      </DialogTitle>
      <DialogContent>
        <div className="form-group">
          <div className="input-group">
            <input aria-label="invite link input" type="text" readOnly className="form-control" value={linkUrl} />
            <div className="input-group-append">
              <Tooltip
                title={<EventLabel name="InviteLinkDialogCopiedTooltip" groupName="CMS.Voucher" />}
                open={showPopper}
                arrow
                disableFocusListener
                disableHoverListener
                disableTouchListener
                placement="top"
              >
                <button aria-label="copy button" ref={copyRef} onClick={onCopyClick} className="input-group-text">
                  <CustomIcon name="copy" />
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <button onClick={onClose} className="cms-button">
          <EventLabel name="InviteLinkDialogClose" groupName="CMS.Voucher" />
        </button>
      </DialogActions>
    </Dialog>
  );
};
